import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Path, useLocation } from 'react-router-dom';

import { storage } from 'APP/packages/storage';
import { RouterLink } from 'APP/router/constants';
import { ProjectInstallationType } from 'CONFIG_TYPES';
import Entities from 'STORE';
import { checkIsCurrentInstallationType } from 'UTILS/checkIsCurrentInstallationType';

interface IAuthorizationViewPresenterParams {
  code: string;
}

interface IAuthorizationViewPresenter {
  isAuthenticated: boolean;
  homePagePath: Path;
}

export const useAuthorizationViewPresenter = (
  params: IAuthorizationViewPresenterParams
): IAuthorizationViewPresenter => {
  const location = useLocation();

  const presenter = useLocalObservable<IAuthorizationViewPresenter>(() => ({
    get isAuthenticated(): boolean {
      return Entities.authStore.isAuthenticated && Entities.usersStore.Me?.isUserValid;
    },

    get homePagePath(): Path {
      return {
        pathname: RouterLink.Main,
        search: location.search,
        hash: '',
      };
    },
  }));

  useEffect(() => {
    if (checkIsCurrentInstallationType([ProjectInstallationType.OnPremiseOnly])) {
      return;
    }

    if (!presenter.isAuthenticated && !params.code && !storage.refreshToken.get()) {
      storage.tenantRouting.remove();
    }
  }, [presenter.isAuthenticated, params.code]);

  return presenter;
};
